import type { FormBlock, FormField } from 'types/forms';

import { FormFieldType } from 'types/forms';

type FieldMapper = (field: FormField) => FormField;

// Visit children before their parent without mutating the original definition.
export const mapFormField = (field: FormField, map: FieldMapper): FormField => {
  if (field.type === FormFieldType.FIELD_ARRAY && field.options) {
    return map({
      ...field,
      options: {
        ...field.options,
        fields: field.options.fields.map((child) => mapFormField(child, map)),
      },
    });
  }
  if (field.type === FormFieldType.OUTCOME_FIELDS && field.options) {
    return map({
      ...field,
      options: {
        ...field.options,
        fields: field.options.fields.map((child) => mapFormField(child, map)),
      },
    });
  }
  return map(field);
};

export const mapFormBlocks = (
  blocks: FormBlock[],
  map: FieldMapper
): FormBlock[] =>
  blocks.map((block) => ({
    ...block,
    fields: block.fields.map((field) => mapFormField(field, map)),
  }));
